// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://citruscountyclerk-vendor.aclarian.com',
  appName: 'Citrus County Clerk | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub0ec3ff7de5bb7cbc3d2fedeade3b950b',
  datadogApplicationId: 'c1133c5f-d3b6-44d5-818d-efa37926feb3',
  datadogService: 'invoicing_citrus_clerk_county',
  ApiKey: 'X9m$Q7t!Lp2@Vr4Z',
  env: 'PROD',
  version: packageInfo.version,
};
